














import Vue from "vue";
import { mapActions } from "vuex";
import { get } from "../api";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    designer: {
      type: Object,
    },
    size: {
      type: String,
      default: "regular",
    },
    icon: {
      type: String,
      default: "Search",
    },
  },
  computed: {
    displayValue(): { name: string; display_name: string } {
      if ((this as any).designer) {
        return (this as any).designer;
      } else {
        return (this as any).getDesignerData();
      }
    },
  },
  inject: {
    updateDesigner: {
      default() {
        return;
      },
    },
    getDesignerData: {
      default() {
        return {
          name: "",
          display_name: "",
        };
      },
    },
  },
  methods: {
    getResource(url: string) {
      let ctx = this;
      if (url.startsWith("/bouncer/v2/users/search")) {
        const query = url.split("&q=")[1];
        return get({
          endpoint: "bouncer.v2.users.search",
          queryType: "PERSON",
          queryString: query,
        }).then((response: { items: any[] }) => {
          return response.items
            .filter((item) => {
              return item.is_enabled;
              // if (item.roles) {
              //   // let userInteriorDesigner = item.roles.find((role: any) => {
              //   //   return role.name === "INTERIOR_DESIGNER";
              //   // });
              //   return item.status === "ACTIVE" ? true : false;
              // } else {
              //   return false;
              // }
            })
            .map((item) => {
              return {
                name: item.id,
                display_name: item.display_name,
                extras: {
                  email: item.email,
                  image_url: item.image_url,
                },
              };
            });
        });
      } else {
        throw new Error("Unrecognized url");
      }
    },
    updateDesignerDetails(value: { name: any; display_name: string }) {
      (this as any).$emit("designerselect", value);
      if ((this as any).updateDesigner) {
        (this as any).updateDesigner(value);
      }
    },
  },
});
